import * as types from './orderSupplierActionTypes';

const initialState = {
  groupedOrderSuppliers: [],
  isLoading: false,
  error: null,
  addOrderSupplierData: null,
  updateOrderSupplierData: null,
  deleteOrderSupplierData: null,
  dropdownData: null,
  dropdownLoading: false,
  dropdownError: null,
  orderDropdownData: null,
  orderDropdownLoading: false,
  orderDropdownError: null,
};

export const orderSupplierReducer = (state = initialState, action) => {
  switch (action.type) {
    // Get Order Supplier
    case types.GET_ORDER_SUPPLIER_REQUEST:
      return { ...state, isLoading: true, error: null };
    case types.GET_ORDER_SUPPLIER_SUCCESS:
      return { 
        ...state, 
        isLoading: false, 
        groupedOrderSuppliers: action.payload?.GroupedOrderSuppliers || [], 
        error: null 
      };
    case types.GET_ORDER_SUPPLIER_ERROR:
      return { ...state, isLoading: false, error: action.payload };

    // Add Order Supplier
    case types.ADD_ORDER_SUPPLIER_REQUEST:
      return { ...state, isLoading: true, error: null };
    case types.ADD_ORDER_SUPPLIER_SUCCESS:
      return { ...state, isLoading: false, addOrderSupplierData: action.payload, error: null };
    case types.ADD_ORDER_SUPPLIER_ERROR:
      return { ...state, isLoading: false, error: action.payload };

    // Add Order Supplier Batch
    case types.ADD_ORDER_SUPPLIER_BATCH_REQUEST:
      return { ...state, isLoading: true, error: null };
    case types.ADD_ORDER_SUPPLIER_BATCH_SUCCESS:
      return { ...state, isLoading: false, error: null };
    case types.ADD_ORDER_SUPPLIER_BATCH_ERROR:
      return { ...state, isLoading: false, error: action.payload };

    // Update Order Supplier
    case types.UPDATE_ORDER_SUPPLIER_REQUEST:
      return { ...state, isLoading: true, error: null };
    case types.UPDATE_ORDER_SUPPLIER_SUCCESS:
      return { ...state, isLoading: false, updateOrderSupplierData: action.payload, error: null };
    case types.UPDATE_ORDER_SUPPLIER_ERROR:
      return { ...state, isLoading: false, error: action.payload };

    // Delete Order Supplier
    case types.DELETE_ORDER_SUPPLIER_REQUEST:
      return { ...state, isLoading: true, error: null };
    case types.DELETE_ORDER_SUPPLIER_SUCCESS:
      return { ...state, isLoading: false, deleteOrderSupplierData: action.payload, error: null };
    case types.DELETE_ORDER_SUPPLIER_ERROR:
      return { ...state, isLoading: false, error: action.payload };

    // Get Order Supplier Dropdown
    case types.GET_ORDER_SUPPLIER_DROPDOWN_REQUEST:
      return { ...state, dropdownLoading: true, dropdownError: null };
    case types.GET_ORDER_SUPPLIER_DROPDOWN_SUCCESS:
      return { ...state, dropdownLoading: false, dropdownData: action.payload,
         dropdownError: null };
    case types.GET_ORDER_SUPPLIER_DROPDOWN_ERROR:
      return { ...state, dropdownLoading: false, dropdownError: action.payload };

    // Get Order Dropdown
    case types.GET_ORDER_DROPDOWN_REQUEST:
      return { ...state, orderDropdownLoading: true, orderDropdownError: null };
    case types.GET_ORDER_DROPDOWN_SUCCESS:
      return { ...state, orderDropdownLoading: false, orderDropdownData: action.payload,
         orderDropdownError: null };
    case types.GET_ORDER_DROPDOWN_ERROR:
      return { ...state, orderDropdownLoading: false, orderDropdownError: action.payload };

    default:
      return state;
  }
};
